<div [ngbTooltip]="isDisabled ? disableHint : ''">
  <div (click)="onSelectWidgetType()" class="card" [ngClass]="{'card-hover' : !isDisabled, 'card-disabled' : isDisabled}">
    <div class="card-body text-center">
      <span [class]="widgetTypeCssClass" class="mb-2 h1"></span>
      <h6 class="h6 mb-0">
        <span [innerHTML]="widgetTypeTitle"></span>
      </h6>
    </div>
  </div>
</div>
